import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface UpgradeModalContextType {
  isOpen: boolean;
  openUpgradeModal: () => void;
  closeUpgradeModal: () => void;
}

const UpgradeModalContext = createContext<UpgradeModalContextType>({
  isOpen: false,
  openUpgradeModal: () => {},
  closeUpgradeModal: () => {},
});

export function UpgradeModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openUpgradeModal = useCallback(() => setIsOpen(true), []);
  const closeUpgradeModal = useCallback(() => setIsOpen(false), []);

  return (
    <UpgradeModalContext.Provider value={{ isOpen, openUpgradeModal, closeUpgradeModal }}>
      {children}
    </UpgradeModalContext.Provider>
  );
}

export function useUpgradeModal(): UpgradeModalContextType {
  return useContext(UpgradeModalContext);
}